/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT'; http://reactdropzone.azurewebsites.net/example/
 */

import configs from 'configs';
export const API_URL = process.env.API_URL;
export const PRESCORING_URL = API_URL + configs.prescoringService.url;
export const PRESCORING_AUTH = configs.prescoringService.auth;

export const APP_MAIN_LOGO = configs.mainLogo;
export const APP_LOGO_INVERTED = configs.invertedLogo;

export const SET_LOADING = 'ideal/App/SET_LOADING';
export const LOGOUT = 'ideal/App/LOGOUT';
export const LOAD_USER = 'ideal/App/LOAD_USER';
export const LOAD_USER_SUCCESS = 'ideal/App/LOAD_USER_SUCCESS';
export const LOAD_USER_ERROR = 'ideal/App/LOAD_USER_ERROR';
export const UPDATE_PROFILE = 'ideal/App/UPDATE_PROFILE';
export const PROFILE_UPDATED_ERROR = 'ideal/App/PROFILE_UPDATED_ERROR';
export const UPDATE_PASSWORD = 'ideal/App/UPDATE_PASSWORD';
export const PASSWORD_UPDATED = 'ideal/App/PASSWORD_UPDATED';
export const PASSWORD_UPDATED_ERROR = 'ideal/App/PASSWORD_UPDATED_ERROR';
export const REQUEST_API_KEY = 'ideal/App/REQUEST_API_KEY';
export const REQUEST_API_KEY_SUCCEED = 'ideal/App/REQUEST_API_KEY_SUCCEED';
export const REQUEST_API_KEY_ERROR = 'ideal/App/REQUEST_API_KEY_ERROR';
export const TOGGLE_MEMBER = 'ideal/App/TOGGLE_MEMBER';
export const TOGGLE_MEMBER_SUCCEED = 'ideal/App/TOGGLE_MEMBER_SUCCEED';
export const TOGGLE_MEMBER_ERROR = 'ideal/App/TOGGLE_MEMBER_ERROR';
export const ADD_MEMBER = 'ideal/App/ADD_MEMBER';
export const ADD_MEMBER_SUCCEED = 'ideal/App/ADD_MEMBER_SUCCEED';
export const ADD_MEMBER_ERROR = 'ideal/App/ADD_MEMBER_ERROR';
export const UPDATE_MEMBER = 'ideal/App/UPDATE_MEMBER';
export const UPDATE_MEMBER_SUCCEED = 'ideal/App/UPDATE_MEMBER_SUCCEED';
export const UPDATE_MEMBER_ERROR = 'ideal/App/UPDATE_MEMBER_ERROR';
export const UPLOAD_LOGO = 'ideal/App/UPLOAD_LOGO';
export const UPLOAD_LOGO_SUCCEED = 'ideal/App/UPLOAD_LOGO_SUCCEED';
export const UPLOAD_LOGO_ERROR = 'ideal/App/UPLOAD_LOGO_ERROR';

/**
 *
 * @type {{min: number, max: number}}
 */
export const DISTANCE_YEARS_RANGE = {
  min: 1000,
  max: 100000,
};

/**
 *
 * @type {{min: number, max: number}}
 */
export const DURATION_RANGE = {
  min: 12,
  max: 60,
};

/**
 *
 * @type {{min: number, max: number}}
 */
export const DEPOSIT_RANGE = {
  min: 0,
  max: 99999,
};

/**
 *
 * @type {{min: number, max: number}}
 */
export const MONTHLY_RATE_RANGE = {
  min: 10,
  max: 9999,
};

/**
 *
 * @type {{PARTNER: string, DISTANCE: string, PRICE: string, DEPOSIT: string, DURATION: string}}
 */
export const PRICE_BOX_LABELS = {
  DEPOSIT: "Scegli l'anticipo",
  DISTANCE: 'Scegli i Km/anno',
  DURATION: 'Scegli la durata',
  PRICE: 'Il canone mensile è %s IVA escl.',
  PARTNER: 'in collaborazione con',
};

export const CALL_TO_ACTIONS_LABELS = {
  DASHBOARD_ALERT: "Scopri l'assistente virtuale",
};

export const SECTIONS_TITLES = {
  DASHBOARD_DOUGHNUT_CHART_TITLE: 'Stato dei preventivi',
  DASHBOARD_NEW: 'Novità',
  DASHBOARD_WIDGET_NEW_QUOTES: 'Nuovi preventivi',
  DASHBOARD_WIDGET_NEW_CUSTOMERS: 'Nuovi clienti',
  DASHBOARD_WIDGET_PROFITS: 'Guadagno potenziale',
  DASHBOARD_WIDGET_EFFECTIVE_PROFITS: 'Guadagno effettivo',
};

export const AREA_TITLES = {
  DASHBOARD_TITLE: 'Dashboard',
};

export const MESSAGES = {
  DASHBOARD_ALERT:
    'Prova il nuovo assistente virtuale grazie al quale puoi velocizzare i tempi di gestione della pratica di noleggio.',
};
